import {
  take,
  fork,
  call,
  put,
  select,
} from 'redux-saga/effects';

import { apiGet } from './callApi';

import actionTypes from '../actionTypes';
import { getToken } from '../selectors';
import {
  failProgressiveMissions,
  successProgressiveMissions,
} from '../actionCreators/progressiveMissions';
import { successExpiredProgressiveMissions } from "../actionCreators/expiredProgressiveMissions";

import apiRoutes from '../../constants/apiRoutes';

function* getProgressiveMissions(data?:any): any {
  try {
    let params = {};
    const headers = {};
    const token = yield select(getToken);

    if (token) {
      params['token'] = token;
      headers['x-access-token'] = JSON.stringify(token);
    }

    if (data?.payload) {
      params = { ...params, ...data.payload };
    }

    const response = yield call(apiGet, 'REACT_APP_GAMEBOX_URL', apiRoutes.GET_PROGRESSIVE_MISSIONS, params, headers);
    if (response.data.success) {
      const filteredExpiredMission = response.data.result.filter((a: { status: string }) => a.status !== 'expired');
      filteredExpiredMission.map((item: { submissions: { filter: (arg0: (i: any) => boolean) => never[] } }) => {
        item.submissions = item?.submissions.filter(i => i.type !== 'registration') || [];
      });
      if (data.payload && Object.keys(data.payload).length > 0) {
        const expiredMission = response.data.result.filter((a: { status: string }) => a.status === 'expired');
        yield put(successExpiredProgressiveMissions(expiredMission))
      } else {
        yield put(successProgressiveMissions(filteredExpiredMission));
      }
    } else {
      yield put(failProgressiveMissions(response?.data?.message));
    }
  } catch (e) {
    yield put(failProgressiveMissions(e));
  }
}

export default function* watchProgressiveMissionsRequest():any {
  while (true) {
    const action = yield take([
      actionTypes.PROGRESSIVE_MISSIONS_REQUEST,
      actionTypes.EXPIRED_PROGRESSIVE_MISSIONS_REQUEST,
    ]);

    yield fork(getProgressiveMissions, action);
  }
}
